import React, { useState, useEffect} from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './apiConfig';
import { getStatusMessage } from './statusMessages';
import { useAuth } from "./AuthContext";
import religionList from './Religion.json';
import casteList from './castes.json';
import occupationList from './occupations.json';
import citiesList from './cities.json';
import statesList from './states.json';
import countryList from './country.json';
import './Details.css';
import { FaMale, FaFemale } from 'react-icons/fa';
import { containsForbiddenContactInfo } from './containsForbiddenContactInfo';

function DetailsForm() {


  const { token } = useAuth();

  const [tokenVal, settokenVal] = useState('')

    useEffect(() => {
       

         if (!token || token.trim() === '') {
             navigate('/login');
          }

        settokenVal(token)
      }, []);

  const navigate = useNavigate();

  const genderOptions = [
  { value: '0', label: <><FaMale className="me-2 text-primary" />Male</> },
  { value: '1', label: <><FaFemale className="me-2 text-danger" />Female</> },
];

  const [formData, setFormData] = useState({
    name: '',
    age: '',
    genderID: '',
    mstatusID: '',
    heightFt: '',
    heightIn: '',
    about: '',
  });

  const [errors, setErrors] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [animateArrow, setAnimateArrow] = useState(false);

  // Converts feet and inches to centimeters
  const convertHeightToCm = () => {
    const ft = parseFloat(formData.heightFt) || 0;
    const inch = parseFloat(formData.heightIn) || 0;
    return Math.round(ft * 30.48 + inch * 2.54);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  let cleanedValue;
  if (name === 'about') {
    // For textarea: allow only letters, numbers, spaces, commas, and full stops
    cleanedValue = value.replace(/[^a-zA-Z0-9.,\s]/g, '');
  } else {
    // For other fields: allow only letters, numbers, and spaces (no punctuation)
    cleanedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
  }
      setFormData((prev) => ({
        ...prev,
        [name]: cleanedValue
      }));
    setAnimateArrow(true)
  };

  // Handles react-select changes and sets IDs and clears manual input
  const handleSelectChange = (selected, idField, textField) => {
    if (selected?.value === '0') {
      setFormData((prev) => ({ ...prev, [idField]: '0', [textField]: '' }));
    } else {
      setFormData((prev) => ({ ...prev, [idField]: selected ? selected.value : '', [textField]: '' }));
    }
  };


const [inputValue, setInputValue] = useState('');

  const makeOptions = (list) => {
  const options = list.map((item) => ({
    value: item.id.toString(),
    label: item.name,
  }));
  // Ensure "Other" is always included
  if (!options.find((opt) => opt.value === '0')) {
    options.push({ value: '0', label: 'Other' });
  }
  return options;
};

  const makeOptionswithOO = (list) => [
    ...list.map((item) => ({ value: item.id.toString(), label: item.name })),
  ];

  const validateForm = () => {
    const errs = [];

    if (!formData.name.trim()) errs.push('Name is required.');
    if (!formData.age.trim()) errs.push('Date of birth is required.');
    if (!formData.genderID) errs.push('Gender is required.');
    if (!formData.mstatusID) errs.push('Marital status is required.');

  
      if (!formData.age || isNaN(formData.age)) {
        errs.push('Valid age is required.');
      } else {
        const ageNum = Number(formData.age);
        if (ageNum < 18 || ageNum > 99) errs.push('Age must be between 18 and 99.');
      }



    if (!formData.heightFt.trim() || isNaN(formData.heightFt) || Number(formData.heightFt) < 0)
      errs.push('Valid height (feet) is required.');

    if (formData.heightIn && (isNaN(formData.heightIn) || Number(formData.heightIn) < 0))
      errs.push('Height (inches) must be a valid number.');

    // Validate height in cm (based on ft/in)
        const heightCm = convertHeightToCm();
        if (!heightCm || isNaN(heightCm)) {
        errs.push('Height must be a valid numeric value.');
        } else if (heightCm < 1 || heightCm > 300) {
         errs.push('Height must be between 1 ft and 9 ft 10 in.');
        }

     if (!formData.about) errs.push('About is required.');

     if(containsForbiddenContactInfo(formData.about))
     {
      errs.push('⚠️ Please don’t share phone numbers, emails, or social media IDs. Doing so may lead to your account being blocked.')
     }


    setTimeout(() => setAnimateArrow(false), 1000);
    return errs;
  };

  


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');
    setLoading(true);

    const validationErrors = validateForm();
    if (validationErrors.length) {
      setErrors(validationErrors);
      setLoading(false);
       setTimeout(() => setAnimateArrow(false), 1000);
      return;
    }

    const payload = {
      ...formData,
      height: convertHeightToCm(),
    };

    try {
        const res = await axios.post(API_ENDPOINTS.DETAILS, payload, {
          headers: {
            token: tokenVal,
          },
        });

        const { result, user, opt, errors: serverErrors } = res.data;
    
        if (result === 1) {
          navigate('/ProfileImageUpload',{ state: 1 }); // Success redirect
        } else {
          const allMessages = [];
    
          if (Array.isArray(serverErrors)) {
            allMessages.push(...serverErrors);
          }
          if (user !== undefined) {
            allMessages.push(getStatusMessage(user));
          }
          if (opt !== undefined) {
            allMessages.push(getStatusMessage(opt));
          }
    
          setErrors(allMessages.length ? allMessages : ['Submission failed.']);
        }
      } catch (err) {

        const status = err.response?.status;
        const data = err.response?.data;
    
        if (status === 400 && Array.isArray(data?.errors)) {
          setErrors(data.errors);
        } else if (status === 400 && (data?.user || data?.opt)) {
          const failMessages = [];
          if (data.opt !== undefined) failMessages.push(getStatusMessage(data.opt));
          setErrors(failMessages);
        } else {
          setErrors(['Server error. Please try again later.']);
        }
      } finally {
         setTimeout(() => setAnimateArrow(false), 1000);
        setLoading(false); // Optional: hide loader
      }
  };

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)',
        paddingTop: '4rem',
      }}
    >
      <div style={{ maxWidth: 480, padding:'10px', width: '100%', margin: '0 auto' }}>
      


        <div className="text-center mb-4">     
          <span className="badge bg-secondary">Step 3 of 4</span>
          <h5 className="mt-2 wedding-heading">Enter Personal details</h5>
        </div>


        <form onSubmit={handleSubmit}>

       <div className="mb-3">
  <label className="form-label text-muted">Full Name</label>
  <input
    type="text"
    name="name"
    className="form-control"
    placeholder="Full Name"
    value={formData.name}
    onChange={handleChange}
    autoComplete="name"
    maxLength={600}
  />
  <div className="d-flex align-items-center mt-1">
  <i className="bi bi-info-circle-fill text-warning me-1 small"></i>
  <small className="text-muted">
    Please enter your correct full name, as you won’t be able to change it later.
  </small>
</div>
</div>

     
      <div className="mb-3">
        <label className="form-label text-muted">Your Age</label>
        <input
          type="number"
          name="age"
          className="form-control"
          placeholder="Enter your age"
          value={formData.age || ''}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, age: e.target.value }))
          }
          min={18}
          max={99}
        />
          <div className="d-flex align-items-center mt-1">
    <i className="bi bi-info-circle-fill text-warning me-1 small"></i>
    <small className="text-muted">
      Age cannot be changed later.
    </small>
  </div>
      </div>

          

 <div className="mb-3">
  <label className="form-label text-muted">Gender</label>
  <Select
  name="genderID"
  value={genderOptions.find(o => o.value === formData.genderID)}
  onChange={(selected) =>
    setFormData((prev) => ({ ...prev, genderID: selected?.value || '' }))
  }
  options={genderOptions}
  placeholder="Select Gender"
  classNamePrefix="react-select"
  isSearchable={false}
/>

  {/* Help text */}
  <div className="d-flex align-items-center mt-1">
    <i className="bi bi-info-circle-fill text-warning me-1 small"></i>
    <small className="text-muted">
      Gender cannot be changed later.
    </small>
  </div>
</div>




          <div className="mb-3">
            <label className="form-label text-muted">Marital Status</label>
            <select
              name="mstatusID"
              className="form-select"
              value={formData.mstatusID}
              onChange={handleChange}
            >
              <option value="">Select Marital Status</option>
              <option value="0">Never Married</option>
              <option value="1">Divorced</option>
              <option value="2">Widow</option>
              <option value="3">Separated</option>
              <option value="4">Married</option>
            </select>
              <div className="d-flex align-items-center mt-1">
    <i className="bi bi-info-circle-fill text-warning me-1 small"></i>
    <small className="text-muted">
      Marital Status cannot be changed later.
    </small>
  </div>
          </div>



<div className="mb-3">
          <div className="d-flex gap-2">
            <div style={{ flex: 1 }}>
              <label className="form-label text-muted">Height (Feet)</label>
              <input
                type="number"
                name="heightFt"
                className="form-control"
                placeholder="Feet"
                value={formData.heightFt}
                onChange={handleChange}
                min={0}
                maxLength={1}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label className="form-label text-muted">Height (Inches)</label>
              <input
                type="number"
                name="heightIn"
                className="form-control"
                placeholder="Inches"
                value={formData.heightIn}
                onChange={handleChange}
                min={0}
                maxLength={2}
              />
            </div>
          </div>
  
  <div className="d-flex align-items-center mt-1">
    <i className="bi bi-info-circle-fill text-warning me-1 small"></i>
    <small className="text-muted">
      Height cannot be changed later.
    </small>
  </div>

</div>




          {/* About You */}
          <div className="mb-3">
  
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
            <label className="form-label text-muted mb-0">About You</label>
            <small className="text-muted d-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
              <i className="bi bi-question-circle-fill text-secondary"></i>
              Please tell us about yourself and provide any missing details.
            </small>
          </div>
            <textarea
              name="about"
              className="form-control"
              rows={4}
              maxLength={600}
              placeholder="Tell us about yourself..."
              value={formData.about}
              onChange={handleChange}
            />
             <div className="text-end text-muted small">
                    {formData.about.length} / 600
            </div>
              <div
  className="mb-2 text-danger small d-flex align-items-start gap-2"
  style={{
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
    padding: '10px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    lineHeight: '1.4',
  }}
>
  <i className="bi bi-exclamation-triangle-fill mt-1" style={{ color: '#d39e00' }}></i>
  <div>
    <strong>Warning:</strong> Do not share phone numbers, email, or any contact/social handles (e.g. WhatsApp, Instagram, Facebook, Telegram, Snapchat, Twitter, LinkedIn, etc.).
    Violating this rule may result in your account being <strong>blocked.</strong>
    <strong>AI Engine will automatically allow contact sharing once a meaningful and respectful conversation has been established.</strong>
  </div>
</div>
          </div>


      <button
        type="submit"
        className="btn w-100 mt-3 d-flex justify-content-between align-items-center px-3"
        style={{ backgroundColor: '#ff69b4', color: 'white', overflow: 'hidden' }}
        disabled={loading}
      >
        <span>{loading ? 'Saving...' : 'Save'}</span>

        <i
          className={`bi bi-arrow-right-circle-fill ${
            animateArrow ? 'move-arrow' : ''
          }`}
          style={{ fontSize: '1.4rem' }}
        ></i>
      </button>



          {message && (
            <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
              {message}
            </div>
          )}

          {errors.length > 0 && (
            <div className="alert alert-danger mt-3" style={{ backgroundColor: '#ffe0e0', color: '#cc0000' }}>
              <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default DetailsForm;
